import { v2 } from '.'

export const freeListApi = searchParams => v2.get('user/free/list', { searchParams }).json() // 自选列表
export const freeDeleteApi = searchParams => v2.get('user/free/delete', { searchParams }).json() // 删除自选
export const freeInsertApi = json => v2.post('user/free/insert', { json }).json() // 添加自选
export const getContractsHotSymbolsApi = searchParams => v2.get('public/config/optional/hot/contracts', { searchParams }).json() // 合约自选 推荐
export const getSpotHotSymbolsApi = searchParams => v2.get('public/config/optional/hot/symbols', { searchParams }).json() // 行情现货推荐
export const getHotSymbolsApi = () => v2.get('public/config/hot/web/symbols').json() // 热门币种
